//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionCopy(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 22H18V6H2V22ZM4 8H16V20H4V8Z" fill="currentColor" /><path d="M6 2V4H20V18H22V2H6Z" fill="currentColor" /></svg>;
}
export default IconActionCopy;